/**
 * React Query hook for manageable users
 * Returns list of users that the current user can manage (self + delegated)
 */

import { useQuery } from '@tanstack/react-query';
import { getManageableUsers } from '@/lib/api/users';

export function useManageableUsers() {
  return useQuery({
    queryKey: ['users', 'manageable'],
    queryFn: getManageableUsers,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 30 * 60 * 1000, // 30 minutes
  });
}
